import {useI18nContext} from "../../../../contexts/I18nContext";
import {useStyles} from './GeoRow.style';
import React from "react";
import LocationOnIcon from '@mui/icons-material/LocationOn';
import GeoRowProperties from "./GeoRowProperties";
import clsx from "clsx";
import { Tooltip } from "@mui/material";
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';

const GeoRow: React.FC<GeoRowProperties> = ({
                                                element,
                                                onSelect,
                                                className,
                                                selected,
                                                serviceName
                                            }) => {
    const classes = useStyles();

    const i18n = useI18nContext();

    const serviceEnabled =
        !serviceName || element?.enableServiceNames?.includes(serviceName);

    return (
        <div className={clsx(
                serviceEnabled
                    ? classes.element_row_container
                    : classes.element_row_container_disabled,
                className,
                selected && classes.active
            )}
             onClick={() => serviceEnabled && onSelect(element)}>
            <div className={classes.icon_info}>
                <LocationOnIcon/>
            </div>

            <div className={classes.text_container}>
                <div>{i18n.translate(element.getLevelText())}</div>
                <div>{element.name}</div>
                <div>{`${i18n.translate(element.getLevelText(element.level - 1))}: ${element.parentInfo}`}</div>
            </div>

            {!serviceEnabled && (
                <Tooltip title="Servicio indisponible para este municipio.">
                    <InfoOutlinedIcon
                        style={{
                            fontSize: 20,
                            marginLeft: 'auto',
                            marginRight: '10px',
                            alignSelf: 'center',
                        }}
                    />
                </Tooltip>
            )}

        </div>
    )
}


export default GeoRow;